// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__iBuIK","header":"ReportDetails_header__2SSUK","title":"ReportDetails_title__3vimH","left":"ReportDetails_left__3IPe_"};